import { render, staticRenderFns } from "./ie.vue?vue&type=template&id=21107e2e&scoped=true&"
import script from "./ie.vue?vue&type=script&lang=js&"
export * from "./ie.vue?vue&type=script&lang=js&"
import style0 from "./ie.vue?vue&type=style&index=0&id=21107e2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21107e2e",
  null
  
)

export default component.exports